import NativeClient from "@/client/native-client";
import store from "@/store";
import {
  PLATE_DISPLAY_FORMAT,
  FRIDGE_ROOM_ID_TYPE,
  PANTRY_STORAGE_TYPE,
  PANTRY_STORAGE_ID,
  PantryPlateDetailPlateInfo,
  StockQuantityInfo,
  PantryListInfo,
  FRIDGE_INFO_ROOM_ID_TYPE,
  PantryFridgeImageData,
  CameraImageMap,
  CameraImageUrlItem,
  CameraImageUrlMap,
  RequstCameraImage,
  PantryPlateInfoData,
  PantryFridgeListInfo,
  FRIDGE_IMAGE_LIST,
  FREEZER_IMAGE_LIST,
  VEGETABLE_IMAGE_LIST,
  FRIDGE_INFO_DOOR_ID_TYPE,
  DOOR_FRENCH_IMAGE_LIST,
  DOOR_RIGHT_IMAGE_LIST,
  DOOR_LEFT_IMAGE_LIST,
  PantryFridgeRoomData,
  PantryCameraDateData,
  PantryVirtualData,
  PANTRY_NEW_STORAGE_TYPE,
  PANTRY_NEW_STORAGE_ID,
  PANTRY_STORAGE_TYPE_TABLE,
  PANTRY_SERVER_STORAGE_TYPE_TABLE,
  PANTRY_DEFAULT_STORAGE_TYPE,
  PANTRY_DEFAULT_STORAGE_ID
} from "@/types/pantry";
import DateUtil from "@/utils/date-util";
import { ApiBaseParams } from "@/types/common";
import { getApplianceIdFindEoj } from "@/utils/common-utils";
import { EOJ_ID } from "@/const/common-const";

export default class PantryUtil {
  static getRoomName(roomId: number | null | undefined) {
    let result = "";
    if (roomId) {
      switch (roomId) {
        case FRIDGE_ROOM_ID_TYPE.FRIDGE:
          result = "冷蔵室";
          break;
        case FRIDGE_ROOM_ID_TYPE.FREEZER:
          result = "冷凍室";
          break;
        case FRIDGE_ROOM_ID_TYPE.VEGETABLE:
          result = "野菜室";
          break;
      }
    }
    return result;
  }
  static getFridgeRoomId(roomId: number | null | undefined) {
    let result = FRIDGE_INFO_ROOM_ID_TYPE.FRIDGE_INFO_FRIDGE;
    if (roomId) {
      switch (roomId) {
        case FRIDGE_ROOM_ID_TYPE.FRIDGE:
        case FRIDGE_ROOM_ID_TYPE.DOOR:
          result = FRIDGE_INFO_ROOM_ID_TYPE.FRIDGE_INFO_FRIDGE;
          break;
        case FRIDGE_ROOM_ID_TYPE.FREEZER:
          result = FRIDGE_INFO_ROOM_ID_TYPE.FRIDGE_INFO_FREEZER;
          break;
        case FRIDGE_ROOM_ID_TYPE.VEGETABLE:
          result = FRIDGE_INFO_ROOM_ID_TYPE.FRIDGE_INFO_VEGETABLE;
          break;
      }
    }
    return result;
  }
  static convertStorageType = (stroage: string | null) => {
    let result = null;
    if (stroage != null) {
      switch (stroage) {
        case PANTRY_STORAGE_TYPE.REFRIGERATOR:
          result = PANTRY_NEW_STORAGE_TYPE.REFRIGERATOR;
          break;
        case PANTRY_STORAGE_TYPE.STORAGE:
          result = PANTRY_NEW_STORAGE_TYPE.NORMAL_TEMPERATURE;
          break;
        case PANTRY_STORAGE_TYPE.DISASTER_PREVENTION:
          result = PANTRY_NEW_STORAGE_TYPE.NORMAL_TEMPERATURE;
          break;
        default:
          result = stroage;
          break;
      }
    }
    return result;
  }
  static convertServerStorageType = (serverType: string | null) => {
    let result = PANTRY_DEFAULT_STORAGE_TYPE;
    if (serverType != null) {
      for (const item of PANTRY_SERVER_STORAGE_TYPE_TABLE) {
        if (item.serverType == serverType) {
          result = item.type;
          break;
        }
      }
    }
    return result;
  }
  static getStorageId = (stroage: string | null) => {
    let result = PANTRY_DEFAULT_STORAGE_ID;
    const newStorage = PantryUtil.convertStorageType(stroage);
    if (newStorage != null) {
      for (const item of PANTRY_STORAGE_TYPE_TABLE) {
        if (item.type == newStorage) {
          result = item.id;
          break;
        }
      }
    }
    return result;
  };
  static getStorageName = (id: number) => {
    let result = PANTRY_DEFAULT_STORAGE_TYPE;
    for (const item of PANTRY_STORAGE_TYPE_TABLE) {
      if (item.id == id) {
        result = item.type;
        break;
      }
    }
    return result;
  };
  static getPlateValue = (plate: PantryPlateDetailPlateInfo) => {
    let result = 0;
    if (plate != null && plate.unit != null && plate.item != null) {
      if (plate.unit.displayFormat == PLATE_DISPLAY_FORMAT.VALUE) {
        result = plate.item.value;
      } else if (plate.unit.displayFormat == PLATE_DISPLAY_FORMAT.GAUGE) {
        const value = plate.item.value;
        result = (plate.unit.unitWeight * value * 10) / plate.unit.fullWeight;
      }
    }
    return result;
  };
  static getPlateValuePlateInfo = (plate: PantryPlateInfoData) => {
    let result = 0;
    if (plate.info) {
      const info = plate.info;
      if (info && info.unit != null && info.item != null) {
        if (info.unit.displayFormat == PLATE_DISPLAY_FORMAT.VALUE) {
          result = info.item.value;
        } else if (info.unit.displayFormat == PLATE_DISPLAY_FORMAT.GAUGE) {
          const value = info.item.value;
          result = (info.unit.unitWeight * value * 10) / info.unit.fullWeight;
        }
      }
    }
    return result;
  };
  static getStockQuantity = (stockQuantity: number | null) => {
    // NativeClient.sendDebugLog("getStockQuantity number=" + stockQuantity);
    let result = 0;
    if (stockQuantity != null) {
      result = stockQuantity / 10;
      result = Math.ceil(result) * 10;
    }
    // NativeClient.sendDebugLog("getStockQuantity result=" + result);
    return result;
  };
  static isShowPlateError = (info: PantryListInfo) => {
    let result = false;
    if (
      info != null &&
      info.plate != null &&
      info.plate.unit != null &&
      info.plate.errorStatus != null &&
      info.plate.errorStatus.errorCode != ""
    ) {
      result = true;
    }
    return result;
  };
  static getImageUrlFilePath = (imageUrl: string) => {
    NativeClient.sendDebugLog("getImageUrlFilePath imageUrl=" + imageUrl);
    const imageUrlLenght = imageUrl.indexOf("?");
    const imageUrlPath =
      imageUrlLenght != -1 ? imageUrl.substring(0, imageUrlLenght) : imageUrl;
    NativeClient.sendDebugLog(
      "getImageUrlFilePath imageUrlPath=" + imageUrlPath
    );
    const fileName = imageUrlPath.substring(imageUrlPath.lastIndexOf("/") + 1);
    NativeClient.sendDebugLog("getImageUrlFilePath fileName=" + fileName);
    return fileName;
  };

  static isCompeleteLoadImageData = (images: Array<PantryFridgeImageData>) => {
    let result = true;
    const map: CameraImageMap = store.getters["pantry/getCameraImageMap"];
    if (map) {
      for (const image of images) {
        const imageData = map.map.get(image.key);
        if (imageData == null) {
          result = false;
          break;
        }
      }
    } else {
      result = false;
    }
    return result;
  };

  static requestFridgeListParam = async (
    roomId: number,
    applianceId: string,
    listener: (roomId: number, applianceId: string) => void
  ) => {
    NativeClient.sendDebugLog(
      "[ImageRoom]requestFridgeListParam roomId=" + roomId
    );
    await Promise.all([NativeClient.getApiParams()]).then(result => {
      listener(roomId, applianceId);
    }).catch(error => {
      NativeClient.sendDebugLog("[ImageRoom]requestFridgeListParam error " + JSON.stringify(error));
      NativeClient.showCameraCloseButton(false);
    });
  };
  static requestFridgeList = async (
    roomId: number,
    applianceId: string,
    listener: (roomId: number, applianceId: string) => void
  ) => {
    NativeClient.sendDebugLog("[ImageRoom]requestFridgeList roomId=" + roomId);
    await Promise.all([
      store.dispatch("pantry/getFridgeListInfo", applianceId)
    ]).then(result => {
      listener(roomId, applianceId);
    }).catch(error => {
      NativeClient.sendDebugLog("[ImageRoom]requestFridgeListParam error " + JSON.stringify(error));
      NativeClient.showCameraCloseButton(false);
    });
  };
  static setFridgeImageUrlListMap = (
    roomId: number,
    fridgeRoomId: number,
    applianceId: string
  ) => {
    NativeClient.sendDebugLog(
      "[ImageRoom]setFridgeImageUrlList applianceId=" +
        applianceId +
        " roomId=" +
        roomId +
        " fridgeRoomId=" +
        fridgeRoomId
    );
    let result = false;
    const imageInfoList = store.getters["pantry/getPantryFridgeListInfo"];
    if (imageInfoList && imageInfoList.rooms) {
      for (const room of imageInfoList.rooms) {
        if (room.roomId != fridgeRoomId) {
          continue;
        }
        for (const image of room.images) {
          const imageFile = PantryUtil.getImageUrlFilePath(image.imageUrl);
          const key = applianceId + "_" + imageFile;
          const urlData = new CameraImageUrlItem(key, image.imageUrl);
          NativeClient.sendDebugLog(
            "[ImageRoom]setFridgeImageUrlList key=" + key
          );
          store.dispatch("pantry/updateCameraImageUrlMap", urlData);
        }
      }
      result = true;
    }
    return result;
  };
  static requestImageLoad = async (
    roomId: number,
    images: Array<PantryFridgeImageData>,
    applianceId: string,
    listener: (roomId: number) => void
  ) => {
    const map: CameraImageUrlMap = store.getters["pantry/getCameraImageUrlMap"];
    const webApiList = new Array<any>();
    for (const image of images) {
      if (map) {
        const imageUrlData = map.map.get(image.key);
        NativeClient.sendDebugLog(
          "[ImageRoom]requestImageLoad roomId=" +
            roomId +
            " image.key=" +
            image.key +
            " imageUrlData=" +
            JSON.stringify(imageUrlData)
        );
        if (imageUrlData) {
          const payload = new RequstCameraImage(
            imageUrlData.imageUrl,
            image.imageUrlFilePath,
            applianceId
          );
          webApiList.push(store.dispatch("pantry/getCameraImageLoad", payload));
        }
      }
    }
    await Promise.all([webApiList]).then(result => {
      NativeClient.sendDebugLog(
        "[ImageRoom]requestImageLoad result roomId=" + roomId
      );
      listener(roomId);
    }).catch(error => {
      NativeClient.sendDebugLog("[ImageRoom]requestFridgeListParam error " + JSON.stringify(error));
      NativeClient.showCameraCloseButton(false);
    });
  };

  static getAreaIdList = (roomId: number, doorTypeId: number) => {
    let areaIdList = null;
    switch (roomId) {
      case FRIDGE_ROOM_ID_TYPE.FRIDGE:
        areaIdList = FRIDGE_IMAGE_LIST;
        break;
      case FRIDGE_ROOM_ID_TYPE.FREEZER:
        areaIdList = FREEZER_IMAGE_LIST;
        break;
      case FRIDGE_ROOM_ID_TYPE.VEGETABLE:
        areaIdList = VEGETABLE_IMAGE_LIST;
        break;
      case FRIDGE_ROOM_ID_TYPE.DOOR:
        switch (doorTypeId) {
          case FRIDGE_INFO_DOOR_ID_TYPE.FRENCH_DOOR:
            areaIdList = DOOR_FRENCH_IMAGE_LIST;
            break;
          case FRIDGE_INFO_DOOR_ID_TYPE.RIGHT_OPEN_DOOR:
            areaIdList = DOOR_RIGHT_IMAGE_LIST;
            break;
          case FRIDGE_INFO_DOOR_ID_TYPE.LEFT_OPEN_DOOR:
            areaIdList = DOOR_LEFT_IMAGE_LIST;
            break;
        }
        break;
    }
    return areaIdList;
  }

  static getDateList = (roomId:number, areaId: number, room: PantryFridgeRoomData) => {
    let selectId = -1;
    const dateList = new Array<PantryCameraDateData>();
    if (room) {
      let areaData = null;
      areaData = room.areaMap.get(areaId);
      if (areaData) {
        selectId = areaData.position;
        let i = 0;
        for (const image of areaData.images) {
          if (image.info) {
            const date = DateUtil.formatYYYYMMDD_hhmm_JST(image.info.capturedTime);
            dateList.push(new PantryCameraDateData(i++, date));
          }
        }
      }
    }
    return dateList;
  };
  
  static getSelectId = (roomId:number, areaId: number, room: PantryFridgeRoomData) => {
    let selectId = -1;
    if (room) {
      let areaData = null;
      areaData = room.areaMap.get(areaId);
      if (areaData) {
        selectId = areaData.position;
      }
    }
    return selectId;
  };

  static getCameraApplianceId = () => {
    const apiBaseParams:ApiBaseParams = store.getters["common/getApiBaseParams"];
    let applianceId = "";
    NativeClient.sendDebugLog("getCameraApplianceId apiBaseParams=" + JSON.stringify(apiBaseParams));
    if (apiBaseParams != null && apiBaseParams.applianceList != null) {
      applianceId = getApplianceIdFindEoj(EOJ_ID.CAMERA,  apiBaseParams.applianceList);
    }
    NativeClient.sendDebugLog("getCameraApplianceId applianceId=" + applianceId);
    return applianceId;
  };

  static getStockValue = (data: PantryVirtualData) => {
    let result = 0;
    if (data != null &&
      data.info != null &&
      data.info.pantryPlateId != null) {
      const unit = data.info.plate ? data.info.plate.unit : null;
      const value = data.info.plate && data.info.plate.item ? data.info.plate.item.value : 0;
      if (unit != null) {
        if (unit.displayFormat == PLATE_DISPLAY_FORMAT.VALUE) {
          result = (unit.unitWeight * value * 100) / unit.fullWeight;
        } else if (unit.displayFormat == PLATE_DISPLAY_FORMAT.GAUGE) {
          result = (unit.unitWeight * value * 10) / unit.fullWeight;
        }
      }
    } else if (data != null && data.info != null) {
      result = PantryUtil.getStockQuantity(data.info.stockQuantity);
    }

    return result;
  };

}
